// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"O1JRNR","input":"xnIzF4"};